import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '@/components/Login'
import Auth from '@/components/auth/SetPassword'

import Dashboard from '@/components/start/Dashboard'
import Administrador from '@/components/administrador/Administrador'
import Menu from '@/components/administrador/menus/Menu'
import Submenus from '@/components/administrador/submenus/Submenus'
import ManageUsers from '@/components/users/Manage'
import CreateUsers from '@/components/users/Create'
import AdminRoles from '@/components/roles/Manage'
import CreateRoles from '@/components/roles/Create'
import Mcargue from '@/components/cargue/Mcargue'
import CargueFacturas from '@/components/cargue/CargueFacturas'
import CargueFacturasCSV from '@/components/cargue/CargueFacturasCSV'
import CargueControl from '@/components/cargue/CargueControl'
import Consultas from '@/components/consultas/Consultas'
import Documentos from '@/components/consultas/Documentos'
import PorAsignar from '@/components/consultas/Facturas'
import PorContabilizar from '@/components/consultas/Facturas'
import Contabilizadas from '@/components/consultas/Facturas'
import SporAsignar from '@/components/seguimiento/Facturas'
import SporContabilizar from '@/components/seguimiento/Facturas'
import Scontabilizadas from '@/components/seguimiento/Facturas'
import Sestados from '@/components/seguimiento/Estados'
import Stiempos from '@/components/seguimiento/Tiempos'
import Mfacturas from '@/components/facturas/Mfacturas'
import Mfechas from '@/components/seguimiento/Mfechas'
import Mseguimiento from '@/components/seguimiento/Mseguimiento'
import Seguimiento from '@/components/seguimiento/Seguimiento'
import Novedades from '@/components/seguimiento/Novedades'
import Reportes from '@/components/seguimiento/Reportes'
import Anulaciones from '@/components/seguimiento/Anulaciones'
import Reportados from '@/components/seguimiento/Reportados'
import Conciliacion from '@/components/seguimiento/Conciliacion'
import Cargados from '@/components/seguimiento/Cargados'
import SinOrden from '@/components/seguimiento/SinOrden'
import Facturas from '@/components/facturas/Facturas'
import Manual from '@/components/facturas/Manual'
import Proveedores from '@/components/facturas/Proveedores'
import Homologaciones from '@/components/facturas/Homologaciones'
import Lideres from '@/components/administrador/lideres/Lideres'
import Estados from '@/components/administrador/estados/Estados'
import Razones from '@/components/administrador/razones/Razones'
import Mcruces from '@/components/seguimiento/Mcruces'

import store from '../store'

Vue.use(VueRouter)
const routes = [
  {
    path: '/',
    name: 'login',
    component: Login,
  },
  {
    path: '/administrador',
    name: 'administrador',
    component: Administrador,
  },
  {
    path: '/consultas',
    name: 'consultas',
    component: Consultas,
  },
  {
    path: '/fechas',
    name: 'fechas',
    component: Mfechas,
  },
  {
    path: '/documento',
    name: 'documento',
    component: Documentos,
  },
  {
    path: '/porasignar',
    name: 'porasignar',
    component: PorAsignar,
  },
  {
    path: '/sporasignar',
    name: 'sporasignar',
    component: SporAsignar,
  },
  {
    path: '/porcontabilizar',
    name: 'porcontabilizar',
    component: PorContabilizar,
  },
  {
    path: '/sporcontabilizar',
    name: 'sporcontabilizar',
    component: SporContabilizar,
  },
  {
    path: '/contabilizadas',
    name: 'contabilizadas',
    component: Contabilizadas,
  },
  {
    path: '/scontabilizadas',
    name: 'scontabilizadas',
    component: Scontabilizadas,
  },
  {
    path: '/sestados',
    name: 'sestados',
    component: Sestados,
  },
  {
    path: '/stiempos',
    name: 'stiempos',
    component: Stiempos,
  },
  {
    path: '/seguimiento',
    name: 'seguimiento',
    component: Mseguimiento,
  },
  {
    path: '/Sseguimiento',
    name: 'Sseguimiento',
    component: Seguimiento,
  },
  {
    path: '/Snovedades',
    name: 'Snovedades',
    component: Novedades,
  },
/*************************************************/
/* Rnovedades Reporte de registro. Genera BPO    */
  {
    path: '/Rnovedades',
    name: 'Rnovedades',
    component: Reportes,
  },
/*********************************************************/
/* RESnovedades Reporte de registro. Genera Novedades    */
  {
    path: '/RESnovedades',
    name: 'RESnovedades',
    component: Reportes,
  },
  {
    path: '/Sreganula',
    name: 'Sreganula',
    component: Anulaciones,
  },
  {
    path: '/Sanulaciones',
    name: 'Sanulaciones',
    component: Anulaciones,
  },
  {
    path: '/facturas',
    name: 'facturas',
    component: Mfacturas,
  },
  {
    path: '/asignacion',
    name: 'asignacion',
    component: Facturas,
  },
  {
    path: '/asignacionprov',
    name: 'asignacionprov',
    component: Facturas,
  },
  {
    path: '/asignacionusuario',
    name: 'asignacionusuario',
    component: Facturas,
  },
  {
    path: '/reasignacion',
    name: 'reasignacion',
    component: Facturas,
  },
  {
    path: '/redisanalista',
    name: 'redisanalista',
    component: Facturas,
  },
  {
    path: '/contabilizar',
    name: 'contabilizar',
    component: Facturas,
  },
  {
    path: '/manual',
    name: 'manual',
    component: Manual,
  },
  {
    path: '/proveedores',
    name: 'proveedores',
    component: Proveedores,
  },
  {
    path: '/proveedoranalista',
    name: 'proveedoranalista',
    component: Proveedores,
  },
  {
    path: '/homologa',
    name: 'homologa',
    component: Homologaciones,
  },
  {
    path: '/razones',
    name: 'razones',
    component: Razones,
  },
  {
    path: '/lideres',
    name: 'lideres',
    component: Lideres,
  },
  {
    path: '/estados',
    name: 'estados',
    component: Estados,
  },
  {
    path: '/submenus',
    name: 'submenus',
    component: Submenus
  },
  {
    path: '/menus',
    name: 'menus',
    component: Menu,
  },
  {
    path: '/cruces',
    name: 'cruces',
    component: Mcruces,
  },
  {
    path: '/Sreportados',
    name: 'Sreportados',
    component: Reportados,
  },
  {
    path: '/Sreptodos',
    name: 'Sreptodos',
    component: Reportados,
  },
  {
    path: '/Sconciliacion',
    name: 'Sconciliacion',
    component: Conciliacion,
  },
  {
    path: '/Scargados',
    name: 'Scargados',
    component: Cargados,
  },
  {
    path: '/Stodos',
    name: 'Stodos',
    component: Cargados,
  },
  {
    path: '/Ssinorden',
    name: 'Ssinorden',
    component: SinOrden,
  },
  {
    path: '/Srepsinorden',
    name: 'Srepsinorden',
    component: SinOrden,
  },
  {
    path: '/users',
    name: 'users',
    component: ManageUsers,
    // beforeEnter: (to, from, next) => {
    //   if(store.state.userRole == 'COM' || store.state.userRole == 'ADM'){
    //     next()
    //   }else{
    //     next({name: 'login'})
    //   }
    // }
  },
  {
    path: '/users/create',
    name: 'users-create',
    component: CreateUsers,
    beforeEnter: (to, from, next) => {
      // if(store.state.userRole == 'COM' || store.state.userRole == 'ADM'){
        next()
      // }else{
      //   next({name: 'login'})
      // }
    }
  },
  {
    path: '/roles',
    name: 'roles',
    component: AdminRoles,
    // beforeEnter: (to, from, next) => {
    //   if(store.state.userRole == 'COM' || store.state.userRole == 'ADM'){
    //     next()
    //   }else{
    //     next({name: 'login'})
    //   }
    // }
  },
  {
    path: '/roles/create',
    name: 'roles-create',
    component: CreateRoles,
    beforeEnter: (to, from, next) => {
      if(store.state.userRole == 'COM' || store.state.userRole == 'ADM'){
        next()
      }else{
        next({name: 'login'})
      }
    }
  },
  {
	path: '/mcargue',
	name: 'mcargue',
	component: Mcargue,
  },
  {
	path: '/cargue',
	name: 'cargue',
	component: CargueFacturas,
  },
  {
	path: '/carguecsv',
	name: 'carguecsv',
	component: CargueFacturasCSV,
  },
  {
	path: '/control',
	name: 'control',
	component: CargueControl,
  },
  {
    path: '/home',
    name: 'home',
    component: Dashboard,
    // beforeEnter: (to, from, next) => {
    //   if(store.state.userRole == 'COM' || store.state.userRole == 'ADM'){
    //     next()
    //   }else{
    //     next({name: 'login'})
    //   }
    // }
  },
  {
    path: '/account',
    name: 'account',
    component: Auth
  },  
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  // let expiresIn = 0;
  // if(store.state.expiration){
  // const now = new Date();
  // expiresIn = (new Date(store.state.expiration)).getTime() - now.getTime();
  // }
  if (to.name !== 'login' && to.name !== 'account' && to.name !== 'registration' && !store.state.isAuthenticated) next({ name: 'login' })
  else next()
})

export default router
